//import config from 'config';
import { authHeader } from 'helper/authHeader';
import { handleResponse } from 'helper/handleResponse';
import {baseUrl} from 'helper/ApiCall';

export const adminUserService = {
    login,
    logout,
    dashboard,
    
    // getAdminUsers,
    // getAdminUser,
    // editAdminUser,
    // storeAdminUser,
    // deleteAdminUser,
}
function login(email, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
    };


    return fetch(baseUrl+'auth/login', requestOptions)
        .then(handleResponse)
        .then(user => {
            // login successful if there's a jwt token in the response
            if (user.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('admin-user', JSON.stringify(user));

                
            }

            return user;
        });
}


function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('admin-user');
}


function dashboard(){

    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };


    return fetch(baseUrl+'dashboard', requestOptions).then(handleResponse);
}

// function getAdminUsers(){
//     const requestOptions = {
//         method: 'GET',
//         headers: authHeader()
//     };



//     return fetch(baseUrl+'getAllAdminUsers', requestOptions).then(handleResponse);
// }

// function getAdminUser(userId){
//     const requestOptions = {
//         method: 'GET',
//         headers: authHeader()
//     };



//     return fetch(baseUrl+'userAdmin/'+userId, requestOptions).then(handleResponse);
// }


// function editAdminUser(adminUserData, userId){
//     const requestOptions = {
//         method: 'PUT',
//         headers: authHeader(),
//         body: JSON.stringify(adminUserData)
//     };

//     return fetch(baseUrl+'userAdmin/'+userId, requestOptions)
//     .then(handleResponse)
//     .then(company => {
//         return company;
//     })
// }

// function storeAdminUser(adminUserData){
//     const requestOptions = {
//         method: 'POST',
//         headers: authHeader(),
//         body: JSON.stringify(adminUserData)
//     };


//     return fetch(baseUrl+'userAdmin', requestOptions)
//             .then(handleResponse)
//             .then(company => {
//                 return company;
//             })
// }


// function deleteAdminUser(userId){
//     const requestOptions = {
//         method: 'DELETE',
//         headers: authHeader()

//     };


//     return fetch(baseUrl+'userAdmin/'+userId, requestOptions).then(handleResponse);
// }



// WEBPACK FOOTER //
// ./src/services/adminUser.js